import React from "react";
import { Form } from "react-bootstrap";
import { useField } from "formik";

const BCSelectField = (props) => {
    const {
        controlId,
        dropDownLabel,
        label,
        dataLabel,
        dataLabel2,
        dataValue,
        size,
        data,
        ...rest
    } = props;
    const [field, meta] = useField(props);

    return (
        <Form.Group controlId={controlId}>
            <Form.Label>{label}</Form.Label>
            <Form.Control
                {...rest}
                {...field}
                as="select"
                isInvalid={meta.error && meta.touched}
                isValid={!meta.error && meta.touched}
                size={size}
            >
                <option>{dropDownLabel}</option>
                {data?.map((item) => (
                    <option value={item[dataValue]} key={item[dataLabel]}>
                        {item[dataLabel]}
                        {dataLabel2 ? `- ${item[dataLabel2]}` : ""}
                    </option>
                ))}
            </Form.Control>
            {meta.error && meta.touched ? (
                <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
            ) : null}
        </Form.Group>
    );
};

BCSelectField.defaultProps = {
    data: [],
    dropDownLabel: "",
    size: "md",
    dataLabel: "name",
    dataValue: "id",
    dataLabel2: ""
};

export default BCSelectField;
